import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Login from './Pages/Login';
import Payment from './Pages/Payment';
import CheckOut from './Pages/CheckOut';
import Registration from './Pages/Registration';
import TopBar from "./Components/TopBar";
import SeeAll from "./Pages/SeeAll";
import Print from "./Pages/Print";
import Printing from "./Pages/Printing";
import TotalNonPaymentHistory from "./Pages/TotalNonPaymentHistory";

const App = () => {
    return (
        <Router>
            <Routes>
                {/* 로그인 페이지에서만 헤더를 숨기기 */}
                <Route path="/" element={<><Login /></>} />
                {/*<Route path="/Home" element={<><TopBar /><Home /></>} />*/}
                <Route path="/Registration" element={<><TopBar /><Registration /></>} />
                <Route path="/Payment" element={<><TopBar /><Payment /></>} />
                <Route path="/CheckOut" element={<><TopBar /><CheckOut /></>} />
                <Route path="/SeeAll" element={<><TopBar /><SeeAll /></>} />
                <Route path="/Print" element={<><TopBar /><Print /></>} />
                <Route path="/Printing" element={<><TopBar /><Printing /></>} />
                <Route path="/TotalNonPaymentHistory" element={<><TopBar /><TotalNonPaymentHistory /></>} />
            </Routes>
        </Router>
    );
};

export default App;
